module.exports = __webpack_public_path__ + "img/calendar.64f99cab.svg";